import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { FilterBar } from './filters';
import { CasesListBody } from './cases';
import { useCasesList } from './use-cases-list';

// /cases/historic route per docs/ui/operator-ui-tds.md §4.1.
//
// Read-only archive of resolved cases. Cursor-paginated + infinite-scrolled via
// the shared useCasesList hook (archived bucket). The list is its own bounded
// scroll region (§18.1) — the page itself never scrolls.

export function CasesHistoricRoute() {
  const { t } = useTranslation('cases');
  const cases = useCasesList({ archived: true });

  return (
    <main className="density-page flex h-full min-h-0 w-full flex-col gap-4 p-6">
      <header>
        <h1 className="text-2xl font-semibold">{t('historic.title')}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t('historic.subtitle')}</p>
      </header>

      <FilterBar hideBuckets />

      <Card className="flex min-h-0 flex-1 flex-col">
        <CardContent className="flex min-h-0 flex-1 flex-col p-0">
          <CasesListBody
            isLoading={cases.isLoading}
            isError={cases.isError}
            rows={cases.items}
            hasNextPage={cases.hasNextPage}
            isFetchingNextPage={cases.isFetchingNextPage}
            fetchNextPage={cases.fetchNextPage}
          />
        </CardContent>
      </Card>
    </main>
  );
}
